import * as actions from 'components/TrustCenter/store/actions';
import {
    Table,
    TableBody,
    TableCell,
    MenuItem,
    MuiThemeProvider,
    Button,
    FormLabel,
    FormGroup,
    TableContainer,
    TextField
} from '@material-ui/core';
import {
    Checkbox,
    TableHead,
    TablePagination,
    TableRow,
    IconButton,
    Select,
    FormHelperText,
    FormControl,
    InputLabel
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cs from 'classnames';
import css from '../AddShipper/AddShipper.module.css';
import agreementCSS from 'components/TrustCenter/ProviderDetails/ProviderDetail.module.css';
import Auxiliary from 'hoc/Auxiliary';
import {
    TABLE_THEME,
    TABLE_THEME_ALT,
    STD_INPUT_FIELD_THEME,
    SWITCH_LABEL
} from 'components/TrustCenter/TrustCenterMuiTheme';
import baseCSS from 'components/TrustCenter/TrustCenter.module.css';
import {
    isNotBlank,
    isNotEmptyList,
    isBlank,
    isNotEmptyObject,
    isEmptyObject
} from 'components/Common/Utils/StringUtils';
import { isOtherGroupInEditMode } from '../Utils/TMSUtils';
import TDialog from 'components/UI/Dialog/TDialog';
import {
    PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME,
    PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME
} from 'components/UI/Button/ButtonMuiTheme';
import ShipperCodeSearch from '../AddShipper/ShipperSearch/ShipperCodeSearch';
import {
    validateWriteAccess,
    validateDeleteAccess
} from 'components/Common/ResourceAccessValidation/ResourceAccessValidation';
import * as Constants from 'constants/Constants';
import { CHECKBOX_STYLE, PrimarySwitch } from 'theme/CommonTheme';
import get from 'lodash/get';
import IdentifierSearch from '../AddShipper/IdentifierSearch/IdentifierSearch';
import { validateField } from 'components/Common/Utils/BaseUtils';
import { MACROPOINT } from 'components/TrustCenter/store/actions/types';
const TMSAgreements = (props) => {
    const {
        newShipperAgreement,
        dataSource,
        updateNewShipper,
        agreements,
        searchText,
        groupName,
        editedAgreements,
        updateEditedAgreements,
        deleteAgreement,
        toggleAgreementEditStatus,
        newAgreementGroup,
        existingAgreementGroup,
        discardChanges,
        resetDiscardFlag,
        setShowDeleteAll,
        executeDelete,
        setExecuteDelete,
        isAgreementInEditMode,
        newTruckAgreements,
        disableOtherOperation,
        sidebarResource,
        hideLocalElement,
        agreementList,
        selectedProvider,
        selectedConnection,
        deleteShipperConfig,
        shipperConfigs
    } = props;

    const [page, setPage] = useState(0);

    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [editIndex, setEditIndex] = useState(-1);

    const [editingAgreement, setEditingAgreement] = useState({});

    const [totalShipperAgreements, setTotalShipperAgreements] = useState([]);

    const [emptyRows, setEmptyRows] = useState(
        rowsPerPage - Math.min(rowsPerPage, totalShipperAgreements.length - page * rowsPerPage)
    );

    const isMacropointProvider = () => {
        return isEmptyObject(agreements)
            ? selectedProvider?.name === MACROPOINT
            : selectedConnection?.name == MACROPOINT;
    };
    const errorFieldObject = {
        datasource: {
            isInvalid: false,
            message: ''
        },
        shipperCode: {
            isInvalid: false,
            message: ''
        },
        shipmentIdentifier: {
            isInvalid: false,
            message: ''
        },
        shipperConfig: {
            isInvalid: false,
            message: ''
        }
    };

    const [editRowErrorFieldObject, setEditRowErrorFieldObject] = useState(
        JSON.parse(JSON.stringify(errorFieldObject))
    );

    const [openConfimation, setOpenConfimation] = useState(false);

    const [singleDeleteIndex, setSingleDeleteIndex] = useState(-1);

    const [multiDeleteIndices, setMultiDeleteIndices] = useState(new Set());

    const [editedAgreementIndices, setEditedAgreementIndices] = useState(new Set());

    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);

    const [isDeleteAccessGranted, setDeleteAccessGranted] = useState(false);

    useEffect(() => {
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.TRUSTCENTER_RESOURCE,
                Constants.TRUSTCENTER_FEATURE
            )
        );

        setDeleteAccessGranted(
            validateDeleteAccess(
                sidebarResource,
                Constants.TRUSTCENTER_RESOURCE,
                Constants.TRUSTCENTER_FEATURE
            )
        );
    }, [sidebarResource]);

    useEffect(() => {
        let totalList = [];

        if (singleDeleteIndex >= 0) {
            setSingleDeleteIndex(-1);
        }
        if (multiDeleteIndices.size > 0) {
            setMultiDeleteIndices(new Set());
            setShowDeleteAll(false);
        }

        if (isNotBlank(groupName)) {
            if (isNotEmptyList(newShipperAgreement[groupName])) {
                newShipperAgreement[groupName].forEach((newAgreement) => {
                    totalList.push(JSON.parse(JSON.stringify(newAgreement)));
                });
            }
            let newLength = totalList.length;
            if (isNotEmptyList(agreements[groupName])) {
                let tempEditedAgreementIndices = new Set();
                agreementList.forEach((existingAgreement) => {
                    let userEditedAgreement = {};
                    if (isNotEmptyList(editedAgreements[groupName])) {
                        userEditedAgreement = editedAgreements[groupName].find(
                            (editedAgreement) => {
                                return editedAgreement.id === existingAgreement.id;
                            }
                        );
                    }
                    if (isNotEmptyObject(userEditedAgreement)) {
                        tempEditedAgreementIndices.add(newLength);
                        totalList.push(JSON.parse(JSON.stringify(userEditedAgreement)));
                    } else {
                        totalList.push(JSON.parse(JSON.stringify(existingAgreement)));
                    }
                    newLength++;
                });
                setEditedAgreementIndices(tempEditedAgreementIndices);
            }
        }

        setTotalShipperAgreements([...totalList]);
        let totalPage = Math.ceil(totalList.length / rowsPerPage) - 1;
        totalPage = totalPage < 0 ? 0 : totalPage;
        let modifiedPage = page;
        if (totalPage < page) {
            setPage(totalPage);
            modifiedPage = totalPage;
        }
        setEmptyRows(
            rowsPerPage - Math.min(rowsPerPage, totalList.length - modifiedPage * rowsPerPage)
        );
    }, [newShipperAgreement, agreements, editedAgreements, groupName]);

    useEffect(() => {
        if (
            discardChanges &&
            (editedAgreements.hasOwnProperty(groupName) ||
                editIndex !== -1 ||
                newShipperAgreement.hasOwnProperty(groupName))
        ) {
            updateEditedAgreements({});
            updateNewShipper({});
            renderRowUneditable();
            setShowDeleteAll(false);
        }
        resetDiscardFlag();
    }, [discardChanges]);

    useEffect(() => {
        if (executeDelete && multiDeleteIndices.size > 0) {
            let existingAgreementsToDelete = [];
            let existingAgreement = {};

            let tempNewShipper = [];

            if (isNotEmptyList(newShipperAgreement[groupName])) {
                tempNewShipper = JSON.parse(JSON.stringify(newShipperAgreement[groupName]));
            }

            for (let deleteIndex of multiDeleteIndices) {
                let agreementToDelete = totalShipperAgreements[deleteIndex];
                if (isNotBlank(agreementToDelete.id)) {
                    existingAgreement = JSON.parse(JSON.stringify(agreementToDelete));
                    existingAgreementsToDelete.push(agreementToDelete.id);
                } else {
                    tempNewShipper.splice(deleteIndex, 1);
                }
            }
            if (
                isNotEmptyList(newShipperAgreement[groupName]) &&
                tempNewShipper.length !== newShipperAgreement[groupName].length
            ) {
                updateNewShipper({ ...tempNewShipper });
            }

            if (isNotEmptyList(existingAgreementsToDelete)) {
                let groupDelete = false;
                if (totalShipperAgreements.length === multiDeleteIndices.size) {
                    groupDelete = true;
                }
                deleteAgreement(
                    existingAgreement.connection_id,
                    existingAgreement.provider_id,
                    existingAgreementsToDelete,
                    existingAgreement.group_name,
                    groupDelete
                );
            }
            setExecuteDelete(false);
        }
    }, [executeDelete]);

    useEffect(() => {
        setPage(0);
    }, [searchText]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setEmptyRows(
            rowsPerPage -
                Math.min(rowsPerPage, totalShipperAgreements.length - newPage * rowsPerPage)
        );
    };

    const setAgreementEditableStatus = (status) => {
        let groupEditMode = {};
        if (status) {
            groupEditMode[groupName] = status;
        }
        toggleAgreementEditStatus(groupEditMode);
    };

    const handleChangeRowsPerPage = (event) => {
        let changedRow = +event.target.value;
        setRowsPerPage(changedRow);
        setPage(0);
        setEmptyRows(changedRow - Math.min(changedRow, totalShipperAgreements.length));
    };

    const renderRowEditable = (index) => {
        setAgreementEditableStatus(true);
        setEditIndex(index);
        setEditingAgreement(JSON.parse(JSON.stringify(totalShipperAgreements[index])));
    };

    const renderRowUneditable = (index) => {
        setAgreementEditableStatus(false);
        setEditIndex(-1);
        setEditingAgreement({});
        setEditRowErrorFieldObject(JSON.parse(JSON.stringify(errorFieldObject)));
    };

    const handleShipperCodeChange = (shipperCode, index) => {
        if (editingAgreement.shipper_code !== Constants.SHIPPER_CODE_ALL_SHIPPER) {
            let tempEditingAgreement = JSON.parse(JSON.stringify(editingAgreement));
            if (isNotEmptyObject(shipperCode)) {
                tempEditingAgreement.shipper_code = shipperCode.shipper_code;
                tempEditingAgreement.name = shipperCode.company_name;
            } else {
                tempEditingAgreement.shipper_code = '';
                tempEditingAgreement.name = '';
            }
            setEditingAgreement(JSON.parse(JSON.stringify(tempEditingAgreement)));
            validateShipperCode(shipperCode, index);
        }
    };

    const handleShipperIdentifiersChange = (identifiers, errorFields, index) => {
        let tempEditingAgreement = JSON.parse(JSON.stringify(editingAgreement));
        tempEditingAgreement.shipment_identifier = identifiers;
        setEditingAgreement(JSON.parse(JSON.stringify(tempEditingAgreement)));
        let tempEditRowErrorFieldObject = JSON.parse(JSON.stringify(editRowErrorFieldObject));
        tempEditRowErrorFieldObject.shipmentIdentifier = errorFields;
        setEditRowErrorFieldObject({ ...tempEditRowErrorFieldObject });
    };

    const handleDataSourceChange = (index) => (event) => {
        let selectedDataSource = dataSource.find((data) => data.id === event.target.value);
        let tempEditingAgreement = JSON.parse(JSON.stringify(editingAgreement));
        tempEditingAgreement.datasource = selectedDataSource;
        tempEditingAgreement.shipper_code = '';
        tempEditingAgreement.name = '';
        tempEditingAgreement.shipment_identifier = [];
        setEditingAgreement({ ...tempEditingAgreement });
        validateDatasource(index)(event);
    };

    const handleAllShipperChange = (index) => (event) => {
        let tempEditingAgreement = JSON.parse(JSON.stringify(editingAgreement));
        if (event.target.checked) {
            tempEditingAgreement.shipper_code = Constants.SHIPPER_CODE_ALL_SHIPPER;
            tempEditingAgreement.name = Constants.SHIPPER_CODE_ALL_SHIPPER;

            let tempErrorFieldList = { ...editRowErrorFieldObject };

            tempErrorFieldList.shipperCode.isInvalid = false;
            tempErrorFieldList.shipperCode.message = '';
            tempErrorFieldList.shipmentIdentifier.isInvalid = false;
            tempErrorFieldList.shipmentIdentifier.message = '';

            setEditRowErrorFieldObject(JSON.parse(JSON.stringify(tempErrorFieldList)));
        } else {
            tempEditingAgreement.shipper_code = '';
            tempEditingAgreement.name = '';
            tempEditingAgreement.shipment_identifier = [];
        }
        setEditingAgreement({ ...tempEditingAgreement });
    };

    const handleMpIdChange = (index) => (event) => {
        const { name, value } = event?.target ?? {};
        let tempErrorFieldList = { ...editRowErrorFieldObject };
        tempErrorFieldList[index] = { ...errorFieldObject };
        const errorFields = validateField(name, value);
        let tempEditRowErrorFieldObject;
        let tempEditingAgreement;
        try {
            tempEditRowErrorFieldObject = JSON.parse(JSON.stringify(editRowErrorFieldObject));
            tempEditingAgreement = JSON.parse(JSON.stringify(editingAgreement));
        } catch {
            tempEditRowErrorFieldObject = {};
            tempEditingAgreement = {};
        }
        tempEditRowErrorFieldObject.shipperConfig = { ...errorFields };
        setEditRowErrorFieldObject({ ...tempEditRowErrorFieldObject });
        tempEditingAgreement.shipperConfig.macropointID = value;
        setEditingAgreement(tempEditingAgreement);
    };

    const saveEditAgreement = (index) => {
        if (isBlank(editingAgreement.id)) {
            let originalshipperConfig = shipperConfigs.find(
                (config) => config.shipperCode === editingAgreement?.shipper_code
            );
            if (isMacropointProvider()) {
                if (
                    originalshipperConfig?.macropointID !==
                    editingAgreement?.shipperConfig?.macropointID
                ) {
                    props.updateShipperConfig(editingAgreement?.shipperConfig);
                }
                let tempUserAddedShippers = { ...newShipperAgreement };
                tempUserAddedShippers[groupName][index] = {
                    ...editingAgreement
                };
                updateNewShipper({ ...tempUserAddedShippers });
            }
        } else {
            let originalshipperConfig = shipperConfigs.find(
                (config) => config.shipperCode === editingAgreement?.shipper_code
            );
            let tempExistingEditedAgreementList = JSON.parse(JSON.stringify(editedAgreements));
            if (Object.keys(tempExistingEditedAgreementList).length === 0) {
                if (isMacropointProvider()) {
                    if (
                        originalshipperConfig?.macropointID !==
                        editingAgreement?.shipperConfig?.macropointID
                    ) {
                        props.updateShipperConfig(editingAgreement?.shipperConfig);
                    }
                }
                tempExistingEditedAgreementList[groupName] = [];
                tempExistingEditedAgreementList[groupName].push(
                    JSON.parse(JSON.stringify(editingAgreement))
                );
            } else {
                let editIndex = -1;

                tempExistingEditedAgreementList[groupName].find((agreement, index) => {
                    if (agreement.id === editingAgreement.id) {
                        editIndex = index;
                        return true;
                    }
                    return false;
                });
                if (editIndex !== -1) {
                    let originalAgreement = get(agreements, `["${groupName}"]`, [])?.find(
                        (agreement) => {
                            if (agreement.id === editingAgreement.id) {
                                return true;
                            }
                            return false;
                        }
                    );
                    if (
                        isMacropointProvider() &&
                        originalshipperConfig?.macropointID !=
                            editingAgreement?.shipperConfig?.macropointID
                    ) {
                        try {
                            tempExistingEditedAgreementList[groupName][editIndex] = JSON.parse(
                                JSON.stringify(editingAgreement)
                            );
                        } catch {
                            tempExistingEditedAgreementList[groupName][editIndex] = {};
                        }
                        props.updateShipperConfig(editingAgreement?.shipperConfig);
                    }
                    if (
                        originalAgreement.datasource.id === editingAgreement.datasource.id &&
                        originalAgreement.name === editingAgreement.name &&
                        originalAgreement.shipper_code === editingAgreement.shipper_code &&
                        !isIdentifiersEdited(editingAgreement, originalAgreement) &&
                        isMacropointProvider() &&
                        originalshipperConfig?.macropointID ===
                            editingAgreement?.shipperConfig?.macropointID
                    ) {
                        tempExistingEditedAgreementList[groupName].splice(editIndex, 1);
                    } else {
                        if (
                            isMacropointProvider() &&
                            originalshipperConfig?.macropointID !=
                                editingAgreement?.shipperConfig?.macropointID
                        ) {
                            props.updateShipperConfig(editingAgreement?.shipperConfig);
                        }
                        tempExistingEditedAgreementList[groupName][editIndex] = JSON.parse(
                            JSON.stringify(editingAgreement)
                        );
                    }
                } else {
                    tempExistingEditedAgreementList[groupName].push(
                        JSON.parse(JSON.stringify(editingAgreement))
                    );
                }
            }
            updateEditedAgreements({ ...tempExistingEditedAgreementList });
        }
        renderRowUneditable(index);
    };

    const revertEditAgreement = (index) => {
        renderRowUneditable(index);
    };

    const getSelectedDatasource = (shipper) => {
        if (shipper.datasource !== undefined && shipper.datasource.id !== undefined) {
            return shipper.datasource.id.toString();
        }
        return '';
    };

    const getSelectedDatasourceInt = (shipper) => {
        if (isNotEmptyObject(shipper?.datasource)) {
            return shipper.datasource.id;
        }
        return Constants.BLANK_DATASOURCE_ID;
    };

    const validateDatasource = (index) => (event) => {
        let tempErrorFieldList = { ...editRowErrorFieldObject };
        tempErrorFieldList[index] = { ...errorFieldObject };
        if (event.target.value === '') {
            tempErrorFieldList[event.target.name].isInvalid = true;
            tempErrorFieldList[event.target.name].message = 'Kindly select an Application';
        } else if (isAllShipperAlreadySelectedExcept(index, +event.target.value)) {
            tempErrorFieldList[event.target.name].isInvalid = true;
            tempErrorFieldList[event.target.name].message = 'All shippers already selected';
        } else {
            tempErrorFieldList[event.target.name].isInvalid = false;
            tempErrorFieldList[event.target.name].message = '';
        }
        setEditRowErrorFieldObject(JSON.parse(JSON.stringify(tempErrorFieldList)));
    };

    const validateShipperCode = (shipperCode, index) => {
        let tempErrorFieldList = { ...editRowErrorFieldObject };
        if (Object.keys(shipperCode).length === 0) {
            tempErrorFieldList.shipperCode.isInvalid = true;
            // downshift itself handles this error
        } else if (isDuplicateExist(shipperCode.shipper_code, index)) {
            tempErrorFieldList.shipperCode.isInvalid = true;
            tempErrorFieldList.shipperCode.message = 'Shipper Code already exist!!';
        } else {
            tempErrorFieldList.shipperCode.isInvalid = false;
            tempErrorFieldList.shipperCode.message = '';
        }
        setEditRowErrorFieldObject(JSON.parse(JSON.stringify(tempErrorFieldList)));
    };

    const isDuplicateExist = (shipperCode, index) => {
        let datasource = editingAgreement.datasource;
        let sameDatasourceShipperList = totalShipperAgreements
            .filter((input, indexTotal) => {
                return input.datasource.id === datasource.id && index !== indexTotal;
            })
            .map((userInput) => {
                return userInput.shipper_code;
            });
        return sameDatasourceShipperList.includes(shipperCode);
    };

    const disableFieldAndButton = () => {
        return (
            !isWriteAccessGranted ||
            disableOtherOperation ||
            isOtherGroupInEditMode(
                newAgreementGroup,
                existingAgreementGroup,
                editedAgreements,
                newShipperAgreement,
                groupName,
                isAgreementInEditMode,
                newTruckAgreements
            )
        );
    };

    const disableSave = (index) => {
        let inValid = false;
        if (disableOtherOperation) {
            return true;
        }
        if (isBlank(editingAgreement.datasource)) {
            inValid = true;
        }
        if (isBlank(editingAgreement.shipper_code) || isBlank(editingAgreement.name)) {
            inValid = true;
        }
        if (
            editRowErrorFieldObject?.datasource?.isInvalid ||
            editRowErrorFieldObject?.shipperCode?.isInvalid ||
            editRowErrorFieldObject?.shipmentIdentifier?.isInvalid ||
            editRowErrorFieldObject?.shipperConfig?.isInvalid
        ) {
            inValid = true;
        }
        if (inValid) {
            return inValid;
        }
        if (
            totalShipperAgreements[index].datasource.id === editingAgreement.datasource.id &&
            totalShipperAgreements[index].name === editingAgreement.name &&
            totalShipperAgreements[index].shipper_code === editingAgreement.shipper_code &&
            !isIdentifiersEdited(totalShipperAgreements[index], editingAgreement) &&
            totalShipperAgreements[index].shipperConfig?.macropointID ===
                editingAgreement.shipperConfig?.macropointID
        ) {
            inValid = true;
        }
        return inValid;
    };

    const isIdentifiersEdited = (editedAgreement, agreement) => {
        let shipmentIdentifiers = new Set(agreement.shipment_identifier);

        if (
            shipmentIdentifiers.size === editedAgreement.shipment_identifier.length &&
            shipmentIdentifiers.size > 0
        ) {
            if (
                editedAgreement.shipment_identifier.some((editedShipmentIdentifier) => {
                    return !shipmentIdentifiers.has(editedShipmentIdentifier);
                })
            ) {
                return true;
            }
        } else if (shipmentIdentifiers.size !== editedAgreement.shipment_identifier.length) {
            return true;
        }

        return false;
    };

    const deleteShipper = (index) => {
        let agreementToDelete = totalShipperAgreements[index];
        if (isBlank(agreementToDelete.id)) {
            if (isMacropointProvider()) {
                let currentShipperCount = 0;
                if (isNotEmptyObject(agreements)) {
                    for (const groupName in agreements) {
                        const currentGroup = agreements[groupName];
                        currentGroup.forEach((item) => {
                            if (
                                item?.shipper_code === agreementToDelete?.shipper_code &&
                                item?.datasource?.id === agreementToDelete?.datasource?.id
                            ) {
                                currentShipperCount++;
                            }
                        });
                    }
                    if (currentShipperCount === 0) {
                        const shipperConfig = shipperConfigs?.find(
                            (item) =>
                                item?.shipperCode ===
                                    newShipperAgreement[groupName][index]?.shipperConfig
                                        ?.shipperCode &&
                                item?.dataSourceId ===
                                    newShipperAgreement[groupName][index]?.shipperConfig
                                        ?.dataSourceId
                        );
                        deleteShipperConfig(shipperConfig?.id);
                    }
                } else {
                    const shipperConfig = shipperConfigs?.find(
                        (item) =>
                            item?.shipperCode ===
                                newShipperAgreement[groupName][index]?.shipperConfig?.shipperCode &&
                            item?.dataSourceId ===
                                newShipperAgreement[groupName][index]?.shipperConfig?.dataSourceId
                    );
                    deleteShipperConfig(shipperConfig.id);
                }
            } else {
                const shipperConfig = shipperConfigs?.find(
                    (item) =>
                        item?.shipperCode ===
                            newShipperAgreement[groupName][index]?.shipperConfig?.shipperCode &&
                        item?.dataSourceId ===
                            newShipperAgreement[groupName][index]?.shipperConfig?.dataSourceId
                );
                deleteShipperConfig(shipperConfig.id);
            }
            let tempUserAddedShippers = { ...newShipperAgreement };
            tempUserAddedShippers[groupName].splice(index, 1);
            updateNewShipper(tempUserAddedShippers);
        } else {
            if (isMacropointProvider()) {
                const deleteCurrentAgreement = () => {
                    deleteAgreement(
                        agreementToDelete.connection_id,
                        agreementToDelete.provider_id,
                        [agreementToDelete.id],
                        agreementToDelete.group_name,
                        groupDelete
                    );
                };
                const groupDelete = totalShipperAgreements.length === 1;
                let currentShipperCount = 0;
                for (const groupName in agreements) {
                    const currentGroup = agreements[groupName];
                    currentGroup.filter((item) => {
                        if (
                            item?.shipper_code === agreementToDelete?.shipper_code &&
                            item?.datasource?.id === agreementToDelete.datasource?.id
                        ) {
                            currentShipperCount++;
                        }
                    });
                }
                if (currentShipperCount === 1) {
                    deleteShipperConfig(agreementToDelete.shipperConfig?.id, () => {
                        deleteCurrentAgreement();
                    });
                } else {
                    deleteCurrentAgreement();
                }
            } else {
                const groupDelete = totalShipperAgreements.length === 1;
                deleteAgreement(
                    agreementToDelete.connection_id,
                    agreementToDelete.provider_id,
                    [agreementToDelete.id],
                    agreementToDelete.group_name,
                    groupDelete
                );
            }
        }
    };

    const toggleShipperSelection = (index) => {
        let tempMultiDeleteIndices = new Set(multiDeleteIndices);
        if (tempMultiDeleteIndices.has(index)) {
            tempMultiDeleteIndices.delete(index);
        } else {
            tempMultiDeleteIndices.add(index);
        }
        if (tempMultiDeleteIndices.size > 0) {
            setShowDeleteAll(true);
        } else {
            setShowDeleteAll(false);
        }
        setMultiDeleteIndices(tempMultiDeleteIndices);
    };

    const handleSelectAll = (event) => {
        if (
            multiDeleteIndices.size === totalShipperAgreements.length &&
            totalShipperAgreements.length > 0
        ) {
            setMultiDeleteIndices(new Set());
            setShowDeleteAll(false);
        } else {
            let tempMultiDeleteIndices = new Set(multiDeleteIndices);
            totalShipperAgreements.forEach((shipper, index) => {
                tempMultiDeleteIndices.add(index);
            });
            setMultiDeleteIndices(tempMultiDeleteIndices);
            if (tempMultiDeleteIndices.size > 0) {
                setShowDeleteAll(true);
            }
        }
    };

    const openConfirmationDialog = (openDialog, index) => {
        setOpenConfimation(openDialog);
        setSingleDeleteIndex(index);
    };

    const confirmDeleteShipper = (index) => {
        setOpenConfimation(false);
        deleteShipper(singleDeleteIndex);
    };

    const isPremiumGroup = () => {
        return (
            isNotBlank(groupName) && Constants.RESERVED_GROUPNAMES.includes(groupName.toUpperCase())
        );
    };

    const disableSelectAllShipper = (index, editingAgreement) => {
        let selectedDatasource = getSelectedDatasourceInt(editingAgreement);

        return (
            selectedDatasource === Constants.BLANK_DATASOURCE_ID ||
            isAllShipperAlreadySelectedExcept(page * rowsPerPage + index, selectedDatasource)
        );
    };

    const isAllShipperAlreadySelectedExcept = (index, selectedDatasource) => {
        // const selectedDatasource = totalShipperAgreements[index].datasource.id;
        let allSelected = totalShipperAgreements.filter((shipper, iteratingIndex) => {
            if (shipper.datasource.id === selectedDatasource && index !== iteratingIndex) {
                if (
                    shipper.shipper_code === Constants.SHIPPER_CODE_ALL_SHIPPER ||
                    shipper.shipment_identifier.includes(
                        Constants.SHIPMENT_IDENTIFIERS_NOT_APPLICABLE
                    )
                ) {
                    return true;
                }
            }
            return false;
        });

        return isNotEmptyList(allSelected);
    };

    const isAllSelected = (index, editingAgreement) => {
        return (
            editingAgreement.shipper_code === Constants.SHIPPER_CODE_ALL_SHIPPER ||
            isAllShipperAlreadySelectedExcept(index, getSelectedDatasourceInt(editingAgreement))
        );
    };

    const isSingleShipperSelected = (index, selectedDatasource) => {
        let singleSelected = totalShipperAgreements.filter((shipper, iteratingIndex) => {
            if (selectedDatasource === shipper.datasource.id && iteratingIndex !== index) {
                if (isNotBlank(shipper.shipper_code)) {
                    return true;
                }
            }
            return false;
        });
        return isNotEmptyList(singleSelected);
    };

    const dialogAction = (
        <div>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME}>
                <Button component="span" onClick={() => openConfirmationDialog(false, -1)}>
                    No
                </Button>
            </MuiThemeProvider>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                <Button component="span" onClick={() => confirmDeleteShipper(singleDeleteIndex)}>
                    Yes
                </Button>
            </MuiThemeProvider>
        </div>
    );
    return (
        <Auxiliary>
            <MuiThemeProvider theme={!hideLocalElement ? TABLE_THEME : TABLE_THEME_ALT}>
                <TableContainer className={agreementCSS.agreementTable}>
                    <Table stickyHeader>
                        <TableHead className={agreementCSS.agreementTableHeader}>
                            <TableRow>
                                {!hideLocalElement && (
                                    <TableCell>
                                        <Checkbox
                                            onChange={handleSelectAll}
                                            disabled={
                                                isMacropointProvider() ||
                                                disableFieldAndButton() ||
                                                !isDeleteAccessGranted
                                            }
                                            checked={
                                                multiDeleteIndices.size ===
                                                    totalShipperAgreements.length &&
                                                totalShipperAgreements.length > 0
                                            }
                                            classes={CHECKBOX_STYLE}
                                        />
                                    </TableCell>
                                )}
                                <TableCell align="left">Shipper Name</TableCell>
                                <TableCell align="left">Shipper Code</TableCell>
                                <TableCell align="left">Shipment Identifiers</TableCell>
                                <TableCell align="left">Application Name</TableCell>
                                {isMacropointProvider() && (
                                    <TableCell align="left">MP Id</TableCell>
                                )}
                                {!hideLocalElement && <TableCell align="left">Actions</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {totalShipperAgreements
                                .slice(rowsPerPage * page, page * rowsPerPage + rowsPerPage)
                                .map((agreement, index) =>
                                    editIndex !== page * rowsPerPage + index ? (
                                        <TableRow
                                            className={
                                                isBlank(agreement.id) ||
                                                editedAgreementIndices.has(
                                                    page * rowsPerPage + index
                                                )
                                                    ? agreementCSS.unsaved
                                                    : null
                                            }
                                            key={page * rowsPerPage + index}
                                            id={agreement.shipper_code}
                                        >
                                            {!hideLocalElement && (
                                                <TableCell>
                                                    <Checkbox
                                                        disabled={
                                                            isMacropointProvider() ||
                                                            disableFieldAndButton() ||
                                                            !isDeleteAccessGranted
                                                        }
                                                        checked={multiDeleteIndices.has(
                                                            page * rowsPerPage + index
                                                        )}
                                                        onChange={() =>
                                                            toggleShipperSelection(
                                                                page * rowsPerPage + index
                                                            )
                                                        }
                                                        classes={CHECKBOX_STYLE}
                                                    />
                                                </TableCell>
                                            )}
                                            <TableCell align="left">{agreement.name}</TableCell>
                                            <TableCell align="left">
                                                {agreement.shipper_code}
                                            </TableCell>
                                            <TableCell align="left">
                                                {isNotEmptyList(agreement.shipment_identifier)
                                                    ? agreement.shipment_identifier.join(', ')
                                                    : ''}
                                            </TableCell>
                                            <TableCell align="left">
                                                {agreement.datasource.name} -{' '}
                                                {agreement.datasource.type}
                                            </TableCell>
                                            {isMacropointProvider() && (
                                                <TableCell align="left">
                                                    {agreement?.shipperConfig?.macropointID}
                                                </TableCell>
                                            )}
                                            {!hideLocalElement && (
                                                <TableCell align="left">
                                                    <IconButton
                                                        id={'edit-shipper'}
                                                        classes={{
                                                            disabled: baseCSS.disabledIconButton
                                                        }}
                                                        disabled={
                                                            disableFieldAndButton() ||
                                                            isNotEmptyList(
                                                                Object.keys(isAgreementInEditMode)
                                                            )
                                                        }
                                                        onClick={() =>
                                                            renderRowEditable(
                                                                page * rowsPerPage + index
                                                            )
                                                        }
                                                    >
                                                        <i
                                                            className={cs(
                                                                'fas fa-pen',
                                                                css.iconButton
                                                            )}
                                                        />
                                                    </IconButton>
                                                    <IconButton
                                                        id={'delete-shipper'}
                                                        classes={{
                                                            disabled: baseCSS.disabledIconButton
                                                        }}
                                                        disabled={
                                                            disableFieldAndButton() ||
                                                            !isDeleteAccessGranted ||
                                                            isNotEmptyList(
                                                                Object.keys(isAgreementInEditMode)
                                                            )
                                                        }
                                                        onClick={() =>
                                                            openConfirmationDialog(
                                                                true,
                                                                page * rowsPerPage + index
                                                            )
                                                        }
                                                    >
                                                        <i
                                                            className={cs(
                                                                'fas fa-trash',
                                                                css.iconButton
                                                            )}
                                                        />
                                                    </IconButton>
                                                    {/* {isBlank(agreement.id) ||
                        (isNotEmptyList(editedAgreements[groupName]) &&
                          editedAgreements[groupName].filter(
                            editedAgreement => editedAgreement.id === agreement.id
                          ).length > 0) ? (
                          <span className={agreementCSS.unsaved}>Not-Saved</span>
                        ) : (
                          ""
                        )} */}
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    ) : (
                                        <TableRow key={index}>
                                            {!hideLocalElement && (
                                                <TableCell>
                                                    <Checkbox
                                                        disabled={
                                                            disableFieldAndButton() ||
                                                            !isDeleteAccessGranted
                                                        }
                                                        checked={multiDeleteIndices.has(
                                                            page * rowsPerPage + index
                                                        )}
                                                        onChange={() =>
                                                            toggleShipperSelection(
                                                                page * rowsPerPage + index
                                                            )
                                                        }
                                                        classes={CHECKBOX_STYLE}
                                                    />
                                                </TableCell>
                                            )}
                                            <TableCell colSpan={2}>
                                                <ShipperCodeSearch
                                                    index={page * rowsPerPage + index}
                                                    allSelected={isAllSelected(
                                                        page * rowsPerPage + index,
                                                        editingAgreement
                                                    )}
                                                    selectedDataSource={getSelectedDatasource(
                                                        editingAgreement
                                                    )}
                                                    ignoreTouched={true}
                                                    selectedCompanyName={editingAgreement.name}
                                                    selectedShipperCode={
                                                        editingAgreement.shipper_code
                                                    }
                                                    sendSelectedShipperCode={
                                                        handleShipperCodeChange
                                                    }
                                                    variant="standard"
                                                    customError={
                                                        editRowErrorFieldObject.shipperCode.message
                                                    }
                                                    isPremiumGroup={isPremiumGroup}
                                                />
                                            </TableCell>
                                            <TableCell align="left">
                                                <IdentifierSearch
                                                    index={page * rowsPerPage + index}
                                                    variant="standard"
                                                    allSelected={isAllSelected(
                                                        page * rowsPerPage + index,
                                                        editingAgreement
                                                    )}
                                                    selectedDatasource={editingAgreement.datasource}
                                                    sendSelectedIdentifiers={
                                                        handleShipperIdentifiersChange
                                                    }
                                                    userAddedShipmentIdentifiers={
                                                        editingAgreement.shipment_identifier
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell align="left">
                                                <div className="row">
                                                    {isPremiumGroup() ? (
                                                        <div className="col-md-3">
                                                            <FormControl component="fieldset">
                                                                <MuiThemeProvider
                                                                    theme={SWITCH_LABEL}
                                                                >
                                                                    <FormLabel component="legend">
                                                                        All Shippers
                                                                    </FormLabel>
                                                                </MuiThemeProvider>
                                                                <FormGroup>
                                                                    <PrimarySwitch
                                                                        disabled={disableSelectAllShipper(
                                                                            page * rowsPerPage +
                                                                                index,
                                                                            editingAgreement
                                                                        )}
                                                                        checked={
                                                                            editingAgreement.shipper_code ===
                                                                            Constants.SHIPPER_CODE_ALL_SHIPPER
                                                                        }
                                                                        onChange={(event) =>
                                                                            handleAllShipperChange(
                                                                                index
                                                                            )(event)
                                                                        }
                                                                    />
                                                                </FormGroup>
                                                            </FormControl>
                                                        </div>
                                                    ) : null}
                                                    <div
                                                        className={
                                                            isPremiumGroup()
                                                                ? 'col-md-9'
                                                                : 'col-md-12'
                                                        }
                                                    >
                                                        <MuiThemeProvider
                                                            theme={STD_INPUT_FIELD_THEME}
                                                        >
                                                            <FormControl
                                                                className="full-width select-form-alignment"
                                                                margin="normal"
                                                                error={
                                                                    editRowErrorFieldObject
                                                                        .datasource.isInvalid
                                                                }
                                                            >
                                                                <InputLabel htmlFor="datasource">
                                                                    Application Name
                                                                </InputLabel>
                                                                <Select
                                                                    id={
                                                                        'datasource' +
                                                                        (page * rowsPerPage + index)
                                                                    }
                                                                    value={getSelectedDatasource(
                                                                        editingAgreement
                                                                    )}
                                                                    disabled={disableOtherOperation}
                                                                    name="datasource"
                                                                    onChange={handleDataSourceChange(
                                                                        page * rowsPerPage + index
                                                                    )}
                                                                    variant="standard"
                                                                    error={
                                                                        editRowErrorFieldObject
                                                                            .datasource.isInvalid
                                                                    }
                                                                >
                                                                    <MenuItem value="">
                                                                        <em>None</em>
                                                                    </MenuItem>
                                                                    {dataSource.map(
                                                                        (data, index) => {
                                                                            return (
                                                                                <MenuItem
                                                                                    value={data.id}
                                                                                    key={index}
                                                                                >
                                                                                    {data.name} -{' '}
                                                                                    {data.type}
                                                                                </MenuItem>
                                                                            );
                                                                        }
                                                                    )}
                                                                </Select>
                                                                <FormHelperText>
                                                                    {
                                                                        editRowErrorFieldObject
                                                                            .datasource.message
                                                                    }
                                                                </FormHelperText>
                                                            </FormControl>
                                                        </MuiThemeProvider>
                                                    </div>
                                                </div>
                                            </TableCell>
                                            {isMacropointProvider() && (
                                                <TableCell>
                                                    <TextField
                                                        fullWidth
                                                        name="macropointId"
                                                        label="MP Id"
                                                        id="mp_id"
                                                        margin="normal"
                                                        className={css.applicationInput}
                                                        required
                                                        error={
                                                            isNotBlank(
                                                                editingAgreement?.shipperConfig
                                                                    ?.macropointID
                                                            ) &&
                                                            editRowErrorFieldObject?.shipperConfig
                                                                ?.isInvalid
                                                        }
                                                        helperText={
                                                            editRowErrorFieldObject?.shipperConfig
                                                                ?.message
                                                        }
                                                        value={
                                                            editingAgreement?.shipperConfig
                                                                ?.macropointID
                                                        }
                                                        onChange={handleMpIdChange(index)}
                                                    />
                                                </TableCell>
                                            )}
                                            {!hideLocalElement && (
                                                <TableCell align="left">
                                                    <IconButton
                                                        id={'check-shipper'}
                                                        disabled={disableSave(
                                                            page * rowsPerPage + index
                                                        )}
                                                        classes={{
                                                            disabled: baseCSS.disabledIconButton
                                                        }}
                                                        onClick={() => {
                                                            saveEditAgreement(
                                                                page * rowsPerPage + index
                                                            );
                                                        }}
                                                    >
                                                        <i
                                                            className={cs(
                                                                'fas fa-check',
                                                                css.iconButton
                                                            )}
                                                        />
                                                    </IconButton>
                                                    <IconButton
                                                        id={'close-shipper'}
                                                        disabled={disableOtherOperation}
                                                        onClick={() => {
                                                            revertEditAgreement(
                                                                page * rowsPerPage + index
                                                            );
                                                        }}
                                                    >
                                                        <i
                                                            className={cs(
                                                                'fas fa-times',
                                                                css.iconButton
                                                            )}
                                                        />
                                                    </IconButton>
                                                </TableCell>
                                            )}
                                        </TableRow>
                                    )
                                )}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 40 * emptyRows, background: '#e5e5e5' }}>
                                    <TableCell colSpan={7} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </MuiThemeProvider>
            <TablePagination
                rowsPerPageOptions={[5, 10, 20]}
                component="div"
                count={totalShipperAgreements.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                    'aria-label': 'previous page'
                }}
                nextIconButtonProps={{
                    'aria-label': 'next page'
                }}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            <TDialog
                id={'cancel_request'}
                open={openConfimation}
                handleClose={() => openConfirmationDialog(false)}
                dialogContentText={'Are you sure you want to delete the shipper code?'}
                dialogTitle={'Confirmation'}
                dialogActions={dialogAction}
            />
        </Auxiliary>
    );
};

const mapStateToProps = (state) => {
    return {
        agreements:
            state.agreement.searchText === ''
                ? state.agreement.agreements
                : state.agreement.filteredAgreements,
        searchText: state.agreement.searchText,
        newShipperAgreement: state.agreement.newShipperAgreement,
        dataSource: state.agreement.dataSource,
        editedAgreements: state.agreement.editedAgreements,
        deletedAgreements: state.agreement.deletedAgreements,
        newAgreementGroup: state.agreement.newAgreementGroup,
        existingAgreementGroup: state.agreement.existingAgreementGroup,
        isAgreementInEditMode: state.agreement.isAgreementInEditMode,
        newTruckAgreements: state.agreement.newTruckAgreements,
        disableOtherOperation: state.agreement.disableOtherOperation,
        identifiers: state.agreement.identifiers,
        selectedProvider: state.agreement.selectedProvider,
        sidebarResource: state.header.sidebarResource,
        selectedConnection: state.agreement.selectedConnection,
        shipperConfigs: state.carrierConfig.shipperConfigs
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateNewShipper: (agreements) => dispatch(actions.updateNewShipper(agreements)),
        updateEditedAgreements: (editedExistingAgreements) => {
            dispatch(actions.updateEditedAgreements(editedExistingAgreements));
        },
        deleteAgreement: (connectionId, provider, agreementIdList, groupName, groupDelete) => {
            dispatch(
                actions.deleteAgreement(
                    connectionId,
                    provider,
                    agreementIdList,
                    groupName,
                    Constants.AGREEMENT_SHIPPER,
                    groupDelete
                )
            );
        },
        updateDeletedAgreements: (agreementIdList) => {
            dispatch(actions.updateDeletedAgreements(agreementIdList));
        },
        toggleAgreementEditStatus: (status) => dispatch(actions.toggleAgreementEditStatus(status)),
        resetDiscardFlag: () => dispatch(actions.discardChanges(false)),
        updateShipperConfig: (...args) => dispatch(actions.updateShipperConfig(...args)),
        deleteShipperConfig: (...args) => dispatch(actions.deleteShipperConfig(...args))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TMSAgreements));
